export class DriveReservationAssetGroup {
  id: number;
  type: string;
  description: string;
  availability: number;
}

export class DriveReservationAssetClass {
  id: number;
  code: string;
  description: string;
  pricing: {
        maximumMileage?: number;
        mileageSurplusCos?: number;
        pricePerDay: number;
        pricePerHour: number;
        pricePerMonth: number;
    };

  externalClassReference?: string;
  groupId: number;
  availability: number;
}

export class DriveReservationAsset {
  id: number;
  description: string;
  brand: {
        name: string;
        logoUrl: string;
        darkModeLogoUrl: string;
    };

  identifier: string;
  registrationNumber: string;
  externalIdentifier?: string;
  groupId: number;
  classId: number;
}

export class DriveReservationSettings {
  groups: boolean;
  classes: boolean;
  assets: boolean;
}

export default class DriveAvailableAssets {
  groups: DriveReservationAssetGroup[] = [];
  classes: DriveReservationAssetClass[] = [];
  assets: DriveReservationAsset[] = [];
  visibilitySettings: DriveReservationSettings;
  bookingSettings: DriveReservationSettings;

  static create(
    groups: DriveReservationAssetGroup[],
    classes: DriveReservationAssetClass[],
    assets: DriveReservationAsset[],
    visibilitySettings: DriveReservationSettings,
    bookingSettings: DriveReservationSettings,
  ): DriveAvailableAssets {
    const availableAssets = new DriveAvailableAssets();
    availableAssets.groups = groups;
    availableAssets.classes = classes;
    availableAssets.assets = assets;
    availableAssets.visibilitySettings = visibilitySettings;
    availableAssets.bookingSettings = bookingSettings;
    return availableAssets;
  }
}